import Hero from "../components/Hero";
import FAQsImag1 from "../../assets/images/FAQ1.jpg";
import Accordion from "../components/Accordion";

const FAQsPage = () => {
  return (
    <div>
      <Hero title="FAQs" subtitle="" backgroundImage={FAQsImag1} />
      <div className="landing-page">
        <div className="column align-center">
          <Accordion title="What is a regular saving plan?">
            <div>
              A regular saving plan involves setting aside money on a consistent
              basis, typically monthly, to build up savings over time.
              <br />
              Saving regularly can help you maintain or improve your financial
              position, protect against inflation, and work towards future
              goals.
            </div>
          </Accordion>
          <Accordion title="Why is budgeting important when saving?">
            <div>
              A monthly budget helps you understand how much you can
              realistically afford to save.
              <br />
              It should include all income sources and expenses, divided into
              essential and non-essential spending.
            </div>
          </Accordion>
          <Accordion title="How do I work out how much I can save?">
            <div>
              By comparing your income with your expenses, you can identify any
              disposable income available for saving.
              <br />
              If little or no disposable income remains, you may need to reduce
              non-essential spending.
            </div>
          </Accordion>
          <Accordion title="How can I build good saving habits?">
            <div>
              Starting to save regularly can be challenging, but consistency
              helps build momentum.
              <br />
              Simple strategies, such as monitoring spending, can help you stay
              on track.
            </div>
          </Accordion>
          <Accordion title="Is it better to save or borrow for purchases?">
            <div>
              Saving for purchases usually means you avoid paying interest and
              additional borrowing costs.
              <br />
              Borrowing can result in paying more overall compared to saving in
              advance.
            </div>
          </Accordion>
          <Accordion title="Is my money safe in a savings account?">
            In the UK, eligible deposits held with authorised banks or building
            societies are typically protected by the Financial Services
            Compensation Scheme (FSCS), up to certain limits.
          </Accordion>
          <Accordion title="How does interest on savings work?">
            <div>
              Savings accounts may pay interest on the money you deposit, either
              monthly or annually.
              <br />
              The interest rate determines how much your savings grow over time.
            </div>
          </Accordion>
          <Accordion title="What types of savings accounts are available?">
            <div>
              There are several types of savings options, including easy access
              accounts, fixed-rate bonds, ISAs, and investment-based products.
              <br />
              Each option offers different levels of access, risk, and potential
              return.
            </div>
          </Accordion>
          <Accordion title="What is inflation and how does it affect savings?">
            <div>
              Inflation is the rise in the cost of goods and services over time,
              which reduces the purchasing power of money.
              <br />
              If your savings earn less than inflation, their real value may
              decrease.
            </div>
          </Accordion>
          <Accordion title="What should I save for?">
            Savings can be used for a variety of goals, including holidays,
            emergencies, future security, and supporting family members.
          </Accordion>
          <Accordion title="Can I save money for my children?">
            <div>
              Yes, you can open savings accounts in your child’s name and build
              funds for their future.
              <br />
              You typically retain control until they reach a certain age.
            </div>
          </Accordion>
          <Accordion title="Are there risks with saving or investing?">
            Some savings and investment products may involve risk, particularly
            those linked to investments rather than cash savings.
          </Accordion>
          <Accordion title="How can I avoid savings scams?">
            <div>
              Be cautious of schemes offering unusually high returns in a short
              time.
              <br />
              Always research providers and consider seeking financial advice.
            </div>
          </Accordion>
        </div>
      </div>
      <div className="footer-legal">
        <div className="footer-legal-text">
          <div className="column align-center">
            <div className=" content-semibold primary">
              Important information
            </div>
            {/* <div className=" content primary">
              It is important to understand the level of risk involved.
            </div> */}
            <div className=" content primary">
              This content is for general guidance only and does not constitute
              financial advice.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQsPage;
